import { TextEditorVariable } from '@components/tiptap/tiptap-ui/variables-dropdown'
import React, { createContext, useContext } from 'react'

interface TextEditorLocalizableContextProps {
  variables: TextEditorVariable[]
}

const TextEditorLocalizableContext =
  createContext<TextEditorLocalizableContextProps | null>(null)

export const TextEditorLocalizableProvider: React.FC<{
  children: React.ReactNode
  variables?: TextEditorVariable[]
}> = ({ children, variables = [] }) => (
  <TextEditorLocalizableContext.Provider value={{ variables }}>
    {children}
  </TextEditorLocalizableContext.Provider>
)

export const useTextEditorLocalizable = () =>
  useContext(TextEditorLocalizableContext) ?? { variables: [] }
